define([
    'text!product-detail/component/size-image.html',
    'product-detail/component/size-image-single',
    'product-detail/component/size-image-animate',
    'lodash'
], function(
    tpl,
    SizeImageSingle,
    SizeImageAnimate,
    _
){
    return {
        template: tpl,
        components: {
            SizeImageSingle: SizeImageSingle,
            SizeImageAnimate: SizeImageAnimate
        },
        props: {
            isAnimate: {
                type: Boolean
            },
            images: {
                type: Array
            },
            bgColor: {
                type: String
            },
            bgColorDown: {
                type: String
            }
        },
        computed: {
            isShowAnimate: function(){
                return this.isAnimate && this.images.length >= 2;
            },
            image: function(){
                return _.last(this.images) || '';
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/size-image.js
// module id = 112
// module chunks = 0